<script lang="ts">
    import type {LocalizeFunction} from '../svelte/types';
    import {getContext} from 'svelte';
    import {INJECTOR_KEY, LOCALIZE_KEY} from '../svelte/utils';
    import type {Injector} from '../svelte/types';
    import type {DataDisplayerSettings} from '../typings/portaro.fe.types';
    import {ExemplarStatusDataService} from './exemplar-status.data-service';
    import KpDataDisplayer from '../commons/ui-components/table/KpDataDisplayer.svelte';

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);
    const injector: Injector = getContext(INJECTOR_KEY);
    const dataService: ExemplarStatusDataService = injector.getByToken(ExemplarStatusDataService.serviceName);

    const settings = {
        loadAll: () => dataService.getAll(),
        columnsSetting: [
            {title: '#', key: 'id'},
            {title: localize( /* @kp-localization commons.popis */ 'commons.popis'), key: 'text'},
            {title: 'Půjčovatelný', key: 'lendable'},
            {title: 'Rezervovatelný', key: 'reservable'},
        ]
    } as unknown as DataDisplayerSettings;
</script>

<div class="row">
    <div class="col-xs-12">
        <h1>{localize(/* @kp-localization commons.ExemplaroveStatusy */ 'commons.ExemplaroveStatusy')}</h1>
    </div>
</div>

<div class="row">
    <div class="col-xs-12">
        <KpDataDisplayer {settings}/>
    </div>
</div>